import ExpiredStatePage from './ExpiredStatePage';
import { ExpiredStatePageProps, ExpiredStatePageValueProps } from './types';

export type { ExpiredStatePageProps, ExpiredStatePageValueProps };
export default ExpiredStatePage;
